export interface TranslatableString {
  fr: string
  en: string
}

export interface Genre {
  id: number
  name: TranslatableString
  description: TranslatableString
}

export interface Author {
  id: number
  family_name: string
  given_name: string
  slug: string
  description: string
  name: string
}
export interface Book {
  id: number
  isbn: number
  name: string
  price: number
  slug: string
  book_edition: ''
  image: {
    thumbnail: string
  }
  authors: Author[]
  genres: []
}

export interface BookEntry {
  id: string
  isbn: string
  title: string
  thumbnailUrl: string
  pixelatedThumbnailUrl?: string
}

export interface SearchBooksResponse {
  current_page: number
  links: string[]
  data: Book[]
}

/** Map internal ID used to predict each book gender by ID from leslibraires.ca
 leslibraires.ca use this list of ids:
1 	Bande dessinée
2 	Cuisine
3 	Essai étranger
4 	Essai québécois
5 	Littérature étrangère
6 	Littérature jeunesse
7 	Littérature policière
8 	Littérature québécoise
9 	Littératures de l'imaginaire
10 	Livre pratique
11 	Poésie et théâtre
**/
export const bookGenderMappingId: Record<number, number> = {
  1: 9,
  2: 4,
  3: 8,
  4: 6,
  5: 3,
  6: 5,
  7: 1,
  8: 10,
  9: 2,
  10: 11,
  11: 7,
}
